var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pt_BR/phone_number/index.js
 ** module id = 969
 ** module chunks = 0
 **/